import React from "react";
import { MenuBoardStoreInfo } from "../../styled/setting";

const Address = ({ company }) => {
  return (
    <MenuBoardStoreInfo>
      {company?.addr && (
        <div>
          <strong>위치안내</strong>
          <span className="cont">
            {company?.addr} {company?.addrDetail}
          </span>
        </div>
      )}
    </MenuBoardStoreInfo>
  );
};

export default Address;
